export default "__VITE_ASSET__Ua0Vc2zf__"